// Display groups keep their existing template key, but send every constituent category.
export function operationCategories(value) {
  if (value === '产业园') return ['产业园', '办公'];
  if (value === '消费') return ['消费', '商业零售'];
  return [...new Set(String(value || '').split('、').map(v => v.trim()).filter(Boolean))];
}

export function operationCategoryQuery(value) {
  const params = new URLSearchParams();
  operationCategories(value).forEach(category => params.append('category_2', category));
  return params.toString();
}

export function matchesOperationCategory(assetCategory, selection) {
  const wanted = operationCategories(selection);
  return String(assetCategory || '').split('、').some(category => wanted.includes(category.trim()));
}
